import { render, staticRenderFns } from "./xeSplitLineSetting.vue?vue&type=template&id=8b2f73d2&scoped=true"
import script from "./xeSplitLineSetting.vue?vue&type=script&lang=js"
export * from "./xeSplitLineSetting.vue?vue&type=script&lang=js"
import style0 from "./xeSplitLineSetting.vue?vue&type=style&index=0&id=8b2f73d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2f73d2",
  null
  
)

export default component.exports